import { DeliveryNoteDTO, Res } from 'core/api';
import * as DeliveryNoteStore from './DeliveryNoteStore';
import { Message } from 'core/ui-next/modal';

export function shouldBeInvoicedAsRefund(notes: DeliveryNoteDTO[]): boolean {
	return notes.sum(d => d.NetAmount) < 0;
}

export async function canBeInvoiced(notes: DeliveryNoteDTO[]): Promise<boolean> {

	const isRefund = notes.sum(d => d.NetAmount) < 0;
	const pendingAmount = notes.sum(d => d.PendingAmount);

	const refundWithPendingAmount = isRefund && pendingAmount > 0;
	const invoiceWithOverPaidAmount = !isRefund && pendingAmount < 0;

	if (notes.length === 0) {
		await Message.show(Res.Msg.MSG_MUST_EXISTS_AT_LEAST_ONE_DELIVERY_NOTE());
		return false;
	}

	if (notes.groupBy(d => d.Customer.Id).length > 1) {
		await Message.show(Res.Msg.MSG_DELIVERY_NOTE_CUSTOMER_MUST_BE_EQUALS());
		return false;
	}


	if (notes.groupBy(d => d.TicketType).length > 1) {
		await Message.show(Res.Msg.MSG_DELIVERY_NOTE_TICKET_TYPE_MUST_BE_EQUALS());
		return false;
	}


	if (!(notes.filter(d => d.ServiceChargeGross !== 0).groupBy(x => { x.AppliedServiceChargeSurchargeRate, x.AppliedServiceChargeVatRate; }).length <= 1)) {
		await Message.show(Res.Msg.MSG_DELIVERY_NOTE_TICKET_SERVICE_CHARGE_VAT_RATE_MUST_BE_EQUALS());
		return false;
	}

	if (refundWithPendingAmount) {
		await Message.show(Res.Msg.MSG_REFUND_DELIVERY_NOTES_PENDING_AMOUNT_MUST_BE_LESS_OR_EQUAL_TO_ZERO());
		return false;
	}

	if (invoiceWithOverPaidAmount) {
		await Message.show(Res.Msg.MSG_INVOICE_DELIVERY_NOTES_PENDING_AMOUNT_MUST_BE_LESS_OR_EQUAL_TO_ZERO());
		return false;
	}

	return true;
}


export async function ensureCanBeReopened(note: DeliveryNoteDTO): Promise<boolean> {

	const canBeOpened = await DeliveryNoteStore.canBeReopened(note.Id);

	if (!canBeOpened.ok)
		return false;

	if (!canBeOpened.value.CanReopen) {
		await Message.show(canBeOpened.value.Message);
		return false;
	}

	return true;
}

